
import './../../../App.css';

export default function Request_7(){
    return(
        <div className='form-header'>
            <ul>
                <li style={{backgroundColor:'#f9e0d0'}}>AUTOJH 도면 자동화 설계 프로그램 임대 문의, 데모프로그램 신청</li>
            </ul>
            <ul>
                <li>구분</li>
                <li>내용</li>
            </ul>
            <ul>
                <li>CAD 종류</li>
                <li>
                    <label>
                        <input
                            type="text"
                            name="r7_CAD종류"
                            placeholder="종류를 입력해주세요"
                            required
                        />
                    </label>
                </li>
            </ul>
            <ul>
                <li>CAD 버전</li>
                <li>
                    <label>
                        <input
                            type="text"
                            name="r7_CAD버전"
                            placeholder="버전을 입력해주세요"
                            required
                        />
                    </label>
                </li>
            </ul>
        </div>
    )
}
